import type { ExtractPropTypes, PropType, StyleValue } from 'vue'

export const cardProps = {
  header: {
    type: String,
  },
  shadow: {
    type: String as PropType<'always' | 'hover' | 'never'>,
    default: 'never',
  },
  headerStyle: {
    type: Object as PropType<StyleValue>,
  },
  bodyStyle: {
    type: Object as PropType<StyleValue>,
  },
  footerStyle: {
    type: Object as PropType<StyleValue>,
  },
} as const

export type CardProps = ExtractPropTypes<typeof cardProps>
